import { render } from "./AppCitacao.vue?vue&type=template&id=54c9ab4c&scoped=true"
import script from "./AppCitacao.vue?vue&type=script&lang=js"
export * from "./AppCitacao.vue?vue&type=script&lang=js"

import "./AppCitacao.vue?vue&type=style&index=0&id=54c9ab4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c9ab4c"]])

export default __exports__